import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["materialTypeSelect", "materialSelect", "variantSelect", "submitButton", "materialTypeClass"]
  static values = {
    materialOrderId: Number
  }

  connect() {
  }

  materialTypeChanged() {
    this.updateMaterialSelect()
    this.resetVariantSelect()
    this.updateSubmitButton()
  }

  materialChanged() {
    this.updateVariantSelect()
    this.updateSubmitButton()
  }

  variantChanged() {
    this.updateSubmitButton()
  }

  updateMaterialSelect() {
    const materialType = this.materialTypeSelectTarget.value

    if (!materialType) {
      this.materialSelectTarget.disabled = true
      this.materialSelectTarget.innerHTML = '<option value="">Sélectionner d\'abord un type</option>'
      return
    }

    this.loadMaterials(materialType)
  }

  loadMaterials(materialType) {
    const materialOrderId = this.materialOrderIdValue
    const url = `/crafting/material_orders/${materialOrderId}/materials_for_type?material_type=${materialType}`

    fetch(url)
      .then(response => {
        console.log("Response status:", response.status)
        return response.json()
      })
      .then(data => {
        console.log("Materials loaded:", data)
        this.materialSelectTarget.disabled = false
        this.materialSelectTarget.innerHTML = '<option value="">Sélectionner un matériau</option>'

        data.materials.forEach(material => {
          const option = document.createElement('option')
          option.value = material.id
          option.text = material.name
          this.materialSelectTarget.appendChild(option)
        })
      })
      .catch(error => {
        console.error('Error loading materials:', error)
      })
  }

  updateVariantSelect() {
    const materialType = this.materialTypeSelectTarget.value
    const materialId = this.materialSelectTarget.value

    if (materialId && (materialType === 'containers' || materialType === 'wicks')) {
      this.loadVariants(materialType, materialId)
    } else {
      this.resetVariantSelect()
    }
  }

  loadVariants(materialType, materialId) {
    const materialOrderId = this.materialOrderIdValue

    fetch(`/crafting/material_orders/${materialOrderId}/variants_for_type?material_type=${materialType}&material_id=${materialId}`)
      .then(response => response.json())
      .then(data => {
        if (data.variants && data.variants.length > 0) {
          this.variantSelectTarget.disabled = false
          this.variantSelectTarget.innerHTML = '<option value="">Sélectionner une variante</option>'

          data.variants.forEach(variant => {
            const option = document.createElement('option')
            option.value = variant.id
            option.text = variant.name
            option.dataset.typeClass = variant.type_class
            this.variantSelectTarget.appendChild(option)
          })
        } else {
          this.resetVariantSelect()
        }
      })
      .catch(error => {
        console.error('Error loading variants:', error)
        this.resetVariantSelect()
      })
  }

  resetVariantSelect() {
    if (!this.hasVariantSelectTarget) return

    this.variantSelectTarget.disabled = true
    this.variantSelectTarget.innerHTML = '<option value="">N/A</option>'
  }

  updateSubmitButton() {
    if (!this.hasSubmitButtonTarget) return

    const materialType = this.materialTypeSelectTarget.value
    const materialId = this.materialSelectTarget.value
    const variantId = this.variantSelectTarget.value

    if ((materialType === 'containers' || materialType === 'wicks')) {
      this.submitButtonTarget.disabled = !variantId

      if (variantId) {
        const selectedOption = this.variantSelectTarget.options[this.variantSelectTarget.selectedIndex]
        const typeClass = selectedOption.dataset.typeClass
        if (this.hasMaterialTypeClassTarget) {
          this.materialTypeClassTarget.value = typeClass
        }
      }
    } else {
      this.submitButtonTarget.disabled = !materialId

      if (materialId && materialType && this.hasMaterialTypeClassTarget) {
        const typeClass = `Crafting::${this.capitalize(this.singularize(materialType))}`
        this.materialTypeClassTarget.value = typeClass
      }
    }
  }

  capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
  }

  singularize(str) {
    // Simple singularization - retire le 's' final
    if (str.endsWith('s')) {
      return str.slice(0, -1)
    }
    return str
  }
}
